import { call, put } from 'redux-saga/effects';
import { photoCaptureIntelligentImageDetailsSuccessAction, photoCaptureIntelligentImageDetailsFailureAction } from '../actions';
import { PhotoCaptureIntelligentImageDetailsService } from '../services';
export function* photoCaptureIntelligentImageDetailsSaga(action, photoCaptureImageDetailsService = new PhotoCaptureIntelligentImageDetailsService()) {
    try {
        const response = yield call({
            context: photoCaptureImageDetailsService,
            fn: photoCaptureImageDetailsService.updatePhotoCaptureImageDetail
        }, action.payload);
        yield put(photoCaptureIntelligentImageDetailsSuccessAction(response));
    }
    catch (error) {
        yield put(photoCaptureIntelligentImageDetailsFailureAction(error.toString()));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureImageDetailsSaga.js.map